<template>
    <div v-if="isReady== true">
        <table>
            <thead>
                <tr>
                    <td>
                            <b-row class="p-md-0 col-md-8 col-sm-11 ">
                                <b-col cols="12" offset-md="3" offset-sm="1" class="form-font  p-md-0">
                                    <div class="header-container">
                                        <b-col sm="12" md="12" class="row p-0">
                                            <b-col cols="12" class="d-flex align-items-center">
                                                <h6 class="header-text">
                                                    {{$t('vitslogan')}}
                                                </h6>
                                            </b-col>
                                        </b-col>
                                    </div>
                                </b-col>
                            </b-row>
                    </td>
                </tr>

                <!--<tr>
                    <td>
                        <div class="header-space">&nbsp;</div>
                    </td>
                </tr>-->
            </thead>

            <tbody>
                <tr>
                    <td>
                        <div class="content">

                            <b-row class="p-md-0 col-md-8 col-sm-11 mb-5  ">
                                <b-col cols="12" offset-md="3" offset-sm="1" class="form-font  p-md-0">
                                    <div class="p-md-0 ">
                                        <b-col cols="12" offset="0" class="pt-3 pr-md-4">
                                            <b-row>


                                                <b-col md="4" sm="12" class="description-top pt-2   nino-mtavruli " style="font-size:15px">{{ $t('policynumber') }}</b-col>
                                                <b-col md="8" sm="12" class="p-2" style="background-color: #fafafa; border: 1px solid #EEEEEE; ">
                                                    <div class="text-center">
                                                        <div class="pol-number">{{data.policyNumber}}</div>
                                                    </div>
                                                </b-col>
                                                <!--Insurer-->
                                                <b-col md="12" sm="12" class="p-2 content-header mt-3">
                                                    <div class="col-md-10 col-sm-12 offset-md-3 text-center nino-mtavruli "> {{ $t('Insurer') }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('companyname') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2 ">
                                                    <div class="text-center">
                                                        <div>{{ $t('JSCardi') }}</div>
                                                    </div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('taxnumber') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2 ">
                                                    <div class="text-center">

                                                        <div>{{ data.compsoccart }}</div>
                                                    </div>
                                                </b-col>

                                                <b-col md="12" sm="12" class="mt-3 p-2 content-header">
                                                    <div class="col-md-10 col-sm-12 offset-md-3 text-center nino-mtavruli">{{ $t('policyholder') }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">
                                                    {{ $t('namesurname') }}
                                                </b-col>
                                                <b-col md="8" sm="12" class="value-background p-2  ">
                                                    <div class="text-center">{{ data.customerName }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top"> {{ $t('bday') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2  ">
                                                    <div class="text-center">{{ data.customerBirthday }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('pnumber') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2  ">
                                                    <div class="text-center">{{ data.customerSocCard }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('address') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2  ">
                                                    <div class="text-center">{{ data.cstomerAddress }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('mob') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2  ">
                                                    <div class="text-center">{{ data.customerPhone }}</div>
                                                </b-col>
                                                <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('email') }}</b-col>
                                                <b-col md="8" sm="12" class="value-background p-2  ">
                                                    <div class="text-center">{{ data.customerEMail }}</div>
                                                </b-col>
                                            </b-row>


                                            <b-row>

                                                <template v-for="(item,index) in data.owner"
                                                          v-if="item.ownerName !== null || item.ownerBirthday !== null || item.ownerSocCard !== null">
                                                    <b-col md="12" sm="12" class="mt-3 p-2 content-header nino-mtavruli ">
                                                        <div class="col-md-10 col-sm-12 offset-md-3 text-center nino-mtavruli">
                                                            {{$t('beneficiary')}}{{ index +1}}
                                                        </div>
                                                    </b-col>
                                                    <b-col md="4" sm="12" class="description p-2 value-border-top">{{$t('usernamesurname')}}</b-col>
                                                    <b-col md="8" sm="12" class="value-background p-2  ">
                                                        <div class="text-center">{{ item.ownerName }}</div>
                                                    </b-col>
                                                    <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('bday') }}</b-col>
                                                    <b-col md="8" sm="12" class="value-background p-2  ">
                                                        <div class="text-center"> {{ item.ownerBirthday }}</div>
                                                    </b-col>
                                                    <b-col md="4" sm="12" class="description p-2 value-border-top">{{ $t('idnumber') }}</b-col>
                                                    <b-col md="8" sm="12" class="value-background p-2  ">
                                                        <div class="text-center">{{ item.ownerSocCard }}</div>
                                                    </b-col>
                                                </template>

                                                <b-col md="12" sm="12" class="mt-3 p-2 content-header nino-mtavruli ">
                                                    <div class="col-sm-12   nino-mtavruli">{{ $t('selectedvitamin') }}</div>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col class="col-12 value-background-main p-0">
                                                    <b-col class="check_box d-sm-block d-md-flex justify-content-md-around p-2">
                                                        <div class="border-bottom-sm inline-sm ">
                                                            <span class="hide-text-md">{{ $t('vitamin') }} A</span>
                                                            <template v-if="data.v1 == 1">
                                                                <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <template v-else>
                                                                <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} A</span>
                                                        </div>
                                                        <div class=" border-bottom-sm inline-sm">
                                                            <span class="hide-text-md">{{ $t('vitamin') }} B</span>
                                                            <template v-if="data.v2 == 1">
                                                                <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <template v-else>
                                                                <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} B</span>
                                                        </div>
                                                        <div class="border-bottom-sm inline-sm">
                                                            <span class="hide-text-md">{{ $t('vitamin') }} C</span>
                                                            <template v-if="data.v3 == 1">
                                                                <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <template v-else>
                                                                <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} C</span>
                                                        </div>
                                                        <div class="border-bottom-sm inline-sm ">
                                                            <span class="hide-text-md">{{ $t('vitamin') }} D</span>
                                                            <template v-if="data.v4 == 1">
                                                                <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <template v-else>
                                                                <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} D</span>
                                                        </div>
                                                        <div class="inline-sm">
                                                            <span class="hide-text-md ">{{ $t('vitamin') }} E</span>
                                                            <template v-if="data.v5 == 1">
                                                                <b-form-checkbox v-model="checked" class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <template v-else>
                                                                <b-form-checkbox class="d-md-flex justify-content-md-around pointer-none"
                                                                                 size="lg"></b-form-checkbox>
                                                            </template>
                                                            <span class="hide-text-sm d-md-block " style="margin-top: 10px">{{ $t('vitamin') }} E</span>
                                                        </div>

                                                    </b-col>

                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <div class="mt-3 col-md-12 col-sm-12">

                                                    <div class="row value-background-main">
                                                        <b-col class="col-md-4 p-0 value-background-sm">
                                                            <div class="content-header  p-2 nino-mtavruli text-center">{{ $t('waitingperiod') }}</div>
                                                            <b-col class="p-2 d-flex">
                                                                <div class="col-sm-6  p-0 d-flex right-border-sm just-sm pl-md-5 justify-content-center  ">
                                                                    <span class="marg-text1">{{ $t('yes') }}</span>
                                                                    <template v-if="data.checkBox1 == 1">
                                                                        <b-form-checkbox v-model="checked" class="pointer-none" id="waiting_period_yes pointer-none"
                                                                                         size="lg"></b-form-checkbox>
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-form-checkbox class="pointer-none" id="waiting_period_yes pointer-none"
                                                                                         size="lg"></b-form-checkbox>
                                                                    </template>
                                                                </div>
                                                                <div class="col-sm-6 p-0 d-flex just-sm justify-content-center pr-md-3 ">
                                                                    <span class="marg-text1 ">{{ $t('no') }}</span>
                                                                    <template v-if="data.checkBox1 == 0">
                                                                        <b-form-checkbox v-model="checked" id="waiting_period_no pointer-none" class="pointer-none"
                                                                                         size="lg"></b-form-checkbox>
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-form-checkbox class="pointer-none" id="waiting_period_no pointer-none"
                                                                                         size="lg"></b-form-checkbox>
                                                                    </template>
                                                                </div>
                                                            </b-col>
                                                        </b-col>


                                                        <div class="col-md-8 col-sm-12 p-0 marg-top">
                                                            <div class=" content-header p-2 nino-mtavruli text-center">
                                                                {{$t('servicescheme')}}
                                                            </div>
                                                            <b-col class="col-md-12 col-sm-12  p-2 sm_display text-center d-sm-block d-md-flex justify-content-md-around ">
                                                                <div class="d-flex justify-content-between border-bottom-sm pl-md-5">
                                                                    <span class="marg-text1">{{$t('byfamilydoctor')}}</span>
                                                                    <template v-if="data.checkBox2 == 1">
                                                                        <b-form-checkbox v-model="checked" id="family_doctor" class="pointer-none"
                                                                                         size="lg"></b-form-checkbox>
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-form-checkbox id="family_doctor" class="pointer-none" size="lg"></b-form-checkbox>
                                                                    </template>
                                                                </div>
                                                                <div class="d-flex justify-content-between pr-md-5">
                                                                    <span class="marg-text1">{{$t('freechoice')}}</span>
                                                                    <template v-if="data.checkBox2 == 0">
                                                                        <b-form-checkbox v-model="checked" id="family_doctor" class="pointer-none"
                                                                                         size="lg"></b-form-checkbox>
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-form-checkbox id="family_doctor" class="pointer-none" size="lg"></b-form-checkbox>
                                                                    </template>
                                                                </div>

                                                            </b-col>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="mt-3 col-md-12 col-sm-12 value-background text-center">
                                                    <b-row>
                                                        <b-col class="row  right-border">
                                                            <div class="col-md-6 description-box p-2">{{$t('yearpremium')}}</div>
                                                            <div class="col-md-6 right-border p-2">{{ data.insurancePremiums }}</div>
                                                        </b-col>
                                                        <b-col class="row ">
                                                            <div class="col-md-6  description-box p-2">{{$t('paymentcount')}}</div>
                                                            <div class="nino-mtavruli col-md-6  p-2">{{ data.paymentCount }}</div>
                                                        </b-col>

                                                    </b-row>
                                                </div>
                                            </b-row>



                                            <b-row>




                                                <b-col class="col-12 mt-3  content-header  text-center bo mt-1 nino-mtavruli p-2">
                                                    {{$t('paymentschedule')}}
                                                </b-col>

                                                <!--responsive-->
                                                <div class=" col-md-12 col-sm-12  text-center payment-sm">
                                                    <b-row>
                                                        <b-col class="row col-md-6 ">
                                                            <div class="nino-mtavruli col-sm-6 pay-head-border payment-title back-color-pay">
                                                                {{$t('date')}}
                                                            </div>
                                                        </b-col>
                                                        <b-col class="row col-md-6 ">
                                                            <div class="col-sm-6 pl-1 pay-head-border payment-title  back-color-pay">
                                                                {{$t('amount')}}
                                                            </div>
                                                        </b-col>


                                                    </b-row>

                                                    <template v-for="i in data.payment" v-if="i.payDate != null || i.payAmaunt != null">
                                                        <b-row>
                                                            <b-col class="row col-md-6">
                                                                <div class="nino-mtavruli col-md-6 right-border payment-sm-border ">{{ i.payDate }}</div>

                                                            </b-col>
                                                            <b-col class="row col-md-6">
                                                                <div class="nino-mtavruli col-md-6 payment-sm-border">{{ i.payAmaunt }}</div>
                                                            </b-col>
                                                        </b-row>
                                                    </template>
                                                </div>
                                                <!--one payment-->
                                                <div class="col-12  payment-md ">

                                                    <div class="row payment-md-border " v-if="data.payment.length<2">
                                                        <template v-for="i in data.payment">


                                                            <div class="col-3   payment-title nino-mtavruli back-color-pay">
                                                                {{$t('date')}}
                                                            </div>
                                                            <div class="col-3 value-background">
                                                                {{ i.payDate }}
                                                            </div>
                                                            <div class="nino-mtavruli col-3 back-color-pay">
                                                                {{$t('amount')}}
                                                            </div>
                                                            <div class="col-3 value-background">
                                                                {{ i.payAmaunt }}
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>

                                                <!--multiple payment-->

                                                <div class="col-12 row  p-0 m-0 payment text-center" v-if="data.payment.length>=2">
                                                    <div class="col-md-6 p-0">
                                                        <div class="col-md-12 row m-0 p-0 payment-md ">
                                                            <div class="col-6 pay-head-border  payment-title  back-color-pay pay-border-left">
                                                                {{$t('date')}}
                                                            </div>
                                                            <div class="col-6 pay-head-border payment-title  back-color-pay">
                                                                {{$t('amount')}}
                                                            </div>
                                                            <template v-for="i in data.payment.slice(0, Math.round( data.payment.length/2))">

                                                                <div class="col-6 green-border pay-border-left">
                                                                    {{ i.payDate }}
                                                                </div>
                                                                <div class="col-6 green-border">
                                                                    {{ i.payAmaunt }}
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 p-0">
                                                        <div class="col-md-12 row m-0 p-0 payment-md text-center">
                                                            <div class="col-6 pay-head-border payment-title back-color-pay">
                                                                {{$t('date')}}
                                                            </div>
                                                            <div class="col-6 pay-head-border payment-title back-color-pay">
                                                                {{$t('amount')}}
                                                            </div>

                                                            <template v-for="i in data.payment.slice(Math.round(data.payment.length/2), data.payment.length)">
                                                                <div class="col-6 green-border">
                                                                    {{ i.payDate }}
                                                                </div>
                                                                <div class="col-6 green-border">
                                                                    {{ i.payAmaunt }}
                                                                </div>
                                                            </template>
                                                        </div>

                                                    </div>
                                                </div>
                                            </b-row>




                                            <b-row>
                                                <b-col md="12" sm="12" class="mt-3 ">
                                                    <b-row style="font-size: 12px">
                                                        <div class="col-sm-12 col-md-3 description-box p-2">{{$t('placeofissue')}}</div>
                                                        <div class="col-sm-12 col-md-3 value-background p-2">{{$t('tbilisi')}}</div>
                                                        <div class="col-sm-12 col-md-3 description-box p-2">{{$t('dateOfissue')}}</div>
                                                        <div class="col-sm-12 col-md-3 value-background p-2">{{ data.contDate }}</div>
                                                    </b-row>
                                                </b-col>
                                                <div class="mt-3 col-md-12 col-sm-12 ">
                                                    <b-row style="font-size: 12px">
                                                        <b-col class="row ">
                                                            <div class="col-md-6 description-box right-border-sm p-2">{{$t('coverfrom')}}</div>
                                                            <div class="col-md-6 right-border value-background p-2">{{ data.fromDate }}</div>
                                                        </b-col>
                                                        <b-col class="row ">
                                                            <div class="col-md-6  description-box p-2">{{$t('including')}}</div>
                                                            <div class="col-md-6 value-background  p-2">{{ data.toDate }}</div>
                                                        </b-col>

                                                    </b-row>
                                                </div>
                                            </b-row>
                                            <b-row>
                                                <b-col class="mt-3 p-0 col-12 policy-text">

                                                    <!--{{ Description.VitaminDesc }}-->
                                                    {{ $t('vitamindesc') }}
                                                </b-col>


                                                <b-col class=" text-center mt-3 col-md-12 ">
                                                    <div class="row ">
                                                        <div class="col-md-8 nino-mtavruli  description-box p-2">{{$t('termsofinsurance')}}</div>

                                                        <div class="col-md-4 p-2  url-text-size">
                                                            <a :href="$t('termsofinsurancelink')" target="_blank">{{ data.condition }}</a>
                                                        </div>
                                                    </div>
                                                </b-col>

                                                <div class="mt-3 col-md-12 col-sm-12 p-0">
                                                    <div class="content-header col-md-12 text-center nino-mtavruli p-2">{{ $t('signature')}}</div>
                                                    <signature class="col-12" />
                                                </div>

                                            </b-row>
                                        </b-col>
                                    </div>

                                </b-col>
                            </b-row>
                        </div>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td>
                        <div class="footer-space">&nbsp;</div>
                    </td>
                </tr>
            </tfoot>
        </table>



        <div class="page-footer">
            <div class="p-0 footer col-12">
                <b-col cols="8" offset-md="2" offset-sm="0" class="p-md-0 ">
                    <div class="d-flex justify-content-between align-items-center mr-4  pb-4 m-lg-n3 pr-md-5">
                        <template v-if="this.isGeo === 1">
                            <img src="@/assets/img/ardi_new_logo.svg" width="100" alt="">
                            <img src="@/assets/img/slogan_new.svg" width="150" alt="">
                        </template>
                        <template v-else>
                            <img src="@/assets/img/ardiNewlogoEN.svg" width="100" alt="">
                            <img src="@/assets/img/timetolifeEN.svg" width="150" alt="">
                        </template>
                    </div>
                </b-col>
            </div>
        </div>

    </div>



</template>

<script>
    import Signature from "@/Medical/components/Signature";
    //import Descriptions from "@/assets/Descriptions.json";

    export default {
        name: "Contract",
        components: {
            Signature
        },
        data() {
            return {
                emptyvalue: 1,
                //Description: Descriptions.items,
                isGeo: 0,
                denial: false,
                cont: this.$route.params.cont,
                cust: this.$route.params.cust,
                checked: true,
                isReady: false,
                data: null,
                datapayment: [
                    { date: '2020.12.01', price: '1' }
                ],
            }
        },

        mounted() {
            this.$http.get(`/policy/GetVitaminInfo/${this.cont}/${this.cust}`).then(r => {
                this.data = r.data;
                if (r.data.isGeo === 1) {
                    this.isGeo = 1;
                }
                this.isReady = true;
                //console.log(r.data);
            }).catch((e) => {
                console.log(e)
            })
        },
        methods: {
            Denial() {
                this.denial = true
            },
        }
    }
</script>

<style scoped>
    @import "~bpg-nino-mtavruli";

    .nino-mtavruli {
        font-family: "BPG Nino Mtavruli", sans-serif;
    }

    .header11, .header-space,
    .footer-space {
        height: 100px;
    }

    .header11 {
        position: fixed;
        top: 0;
    }



    .pol-number {
        font-size: 15px;
        font-weight: bold;
    }


    .page-footer {
        position: absolute;
        bottom: 5px;
    }


    .footer {
        position: fixed;
        bottom: 0;
    }

    .description-top {
        background-color: #00A788;
        color: #fff;
    }

    .description-box {
        background-color: #00a987;
        color: #fff;
    }

    .url-text-size {
        font-size: 14px;
        border: 1px solid #EEEEEE;
    }

    button.accept-text.btn.btn-outline-danger.mr-3 {
        color: black !important;
        border-color: #dc3545 !important;
    }


    table {
        width: 100%;
    }

    .green-border {
        border-collapse: collapse;
        border-bottom: 1px solid #41A546;
        border-right: 1px solid #41A546;
    }

    .pay-border-left {
        border-left: 1px solid #41A546;
    }

    .pay-head-border {
        /*border: 1px solid #41A546;*/
        border-collapse: collapse;
        border-bottom: 1px solid #41A546;
        border-right: 1px solid #41A546;
    }

    .description-box {
        background: #007960;
        color: #fafafa;
    }

    .desc-vit {
        color: #007960;
        font-weight: bold;
    }

    .right-border {
        border-right: 1px solid #EEEEEE;
    }


    header, h1 {
        font-size: 26px;
        color: #007960;
    }

    .ardi-logo {
        align-self: center;
    }

    #print-header {
        padding: 15px 0;
        display: table-header-group;
    }


    .content-header {
        background-color: #005745;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 12px;
    }

    .btn-width {
        width: 130px;
    }

    .value-background {
        border: 1px solid #EEEEEE;
        font-size: 12px;
    }

    .value-background-main {
        background-color: #fafafa !important;
        border: 1px solid #EEEEEE;
        font-size: 12px;
    }

    .value-background-header {
        background-color: #fafafa !important;
        font-size: 12px;
    }

    .value-hide {
        color: white;
    }

    .value-border-top {
        border-top: 1px solid #00A788;
    }

    .marg-text1 {
        margin-top: 5px;
        margin-right: 10px;
    }

    .ardi-logo-sm {
        display: none;
    }

    .payment-sm {
        display: none;
    }

    .text-center-url {
        height: 38px;
        text-align: center;
        vertical-align: middle;
        line-height: 38px;
    }

    .payment-md-border {
        border: 1px solid #00A886;
        border-collapse: collapse;
        font-size: 10pt;
    }

    .pointer-none {
        pointer-events: none !important;
    }

    .back-color-pay {
        background-color: #D0AAD9;
        color: #FAFAFA;
    }

    .hide-text-md {
        display: none;
    }

    .policy-text {
        font-size: 12px;
    }

    .accept-text {
        font-size: 14px;
    }

    .custom-checkbox.b-custom-control-lg ::before, .input-group-lg .custom-checkbox ::before {
        border-color: #2AAB6E !important;
    }

    .header-container {
        background-color: #D9D8D6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-left: 200px;
        height: 118px;
        overflow: hidden;
        flex-wrap: wrap;
    }

    .header-text {
        color: #007960;
        font-size: 26px;
        font-family: "FiraGo", sans-serif;
        line-height: 100%;
        margin: 0;
        font-weight: 900;
    }


    @media print {
        div {
            break-inside: avoid !important;
        }

        .footer {
            break-inside: avoid !important;
            page-break-after: always;
            page-break-before: always;
        }
    }

    @media (max-width: 500px) {

        .custom-control-label:after, .custom-control-label:before {
            position: unset !important;
        }

        .sm_display {
            display: block;
        }

        .marg-top {
            margin-top: 1rem !important;
        }

        .row {
            position: unset !important;
        }

        .border-bottom-sm {
            border-bottom: 1px solid #EEEEEE;
        }

        .value-background-sm {
            background-color: #fafafa !important;
            border: 1px solid #EEEEEE;
            font-size: 12px;
        }

        .just-sm {
            justify-content: space-between !important;
        }

        .right-border-sm {
            border-right: 1px solid #EEEEEE;
        }

        .ardi-logo {
            display: none;
        }

        .ardi-logo-sm {
            display: block;
            margin-top: 7px;
        }

        .payment-md {
            display: none;
        }

        .payment-sm {
            display: block;
        }

        .payment-sm-border {
            border: 1px solid #00A886;
            border-collapse: collapse;
            font-size: 10pt;
        }

        .inline-sm {
            display: flex;
            justify-content: space-between;
        }

        .hide-text-sm {
            display: none;
        }

        .hide-text-md {
            display: block;
        }

        .sm-pad {
            padding: 23px 23px;
        }
    }
</style>